import React from 'react'
import { Container } from './Container'

interface INavigatorViewProps {
  children: JSX.Element | JSX.Element[]
}

/**
 * A responsive template that displays the primary navigation for the application.
 * @param props A configuration for the content and display of this template.
 */
export const Layout: React.FC<INavigatorViewProps> = (props) => (
  <Container className="flex-col min-h-screen">{props.children}</Container>
)
